module.exports = __webpack_public_path__ + "media/customizations/unionparklife/back-3f219f4e723752399ac11d0894d175ac.jpg";